import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { UrlBuilder } from '../../core';
import { UserPermissionsStorage } from '../../user-permissions/user-permissions-storage';

@Component({
    selector: 'admin-activity-reports',
    template: require('../../shared/tabs.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminActivityReportsComponent {
    public tabsCategories = this.userPermissionsStorage.userPermissions.pipe(map(permissions => {
        const tabs = [{
            name: 'Documents',
            url: this.urlBuilder
                .esa()
                .admin()
                .activityReports()
                .documents()
                .url()
        }, {
            name: 'Protocol Access',
            url: this.urlBuilder
                .esa()
                .admin()
                .activityReports()
                .protocolAccess()
                .url()
            }, {
                name: 'Email Notifications',
                url: this.urlBuilder
                    .esa()
                    .admin()
                    .activityReports()
                    .emailNotificationAlerts()
                    .url()
            }];

        if (permissions.has('AccessInvestigationReport')) {
            tabs.push({
                name: 'Access Investigation',
                url: this.urlBuilder
                    .esa()
                    .admin()
                    .activityReports()
                    .accessInvestigation()
                    .url()
            });
        }

        return tabs;
    }));

    constructor(
        private readonly urlBuilder: UrlBuilder,
        private readonly userPermissionsStorage: UserPermissionsStorage
    ) { }
}
